module.exports = __webpack_public_path__ + "img/icono_vehiculo.ace6ccc8.svg";